export const APP_COMMIT = "1bec0be5516944ca0b2ac660e41851faec4aa239";
export const DESIRED_IAC_VERSIONS: Readonly<Record<string, string>> = {"avd":"c3aef8b27a54","base":"c91550fcb440","swa":"9eeca0565bf6"};
